import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { incrementProgressBar } from '~/ducks/paperwork';
import { calculateProgress } from '../util';
import { PageNumber } from '~/components/Paperwork/interfaces';
import { SectionNumber } from '../constants';
import { SectionPage } from '../interfaces';
import { isProviderGroupLocation } from '~/core/util/location';
import { useSolvSelector } from '~/reducers';
import { PGSectionNumber } from '../providerGroups/constants';

export const useIncrementProgress = (
  sectionNumber: SectionNumber | PGSectionNumber,
  pageNumber: PageNumber,
  customPages?: Map<number, SectionPage>
) => {
  const dispatch = useDispatch();
  const isProviderGroup = useSolvSelector((state) =>
    isProviderGroupLocation(state.location as LocationInterface)
  );

  const progress = useMemo(
    () =>
      calculateProgress(
        sectionNumber,
        isProviderGroup ? PGSectionNumber : SectionNumber,
        pageNumber,
        customPages
      ),
    [sectionNumber, isProviderGroup, pageNumber, customPages]
  );

  useEffect(() => {
    dispatch(incrementProgressBar(progress));
  }, [progress, dispatch]);
};
